import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, StaffAssignmentFilter, ComplainSearch } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, Staff_Search_Assigment } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { CallDescriptionLookup, CallCategoryLookup, LocationLookup } from '../../Models/GlobalEntities';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../Services/UserService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'StaffJobList',
    templateUrl: './StaffJobList.html'
})

export class StaffJobList extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    Model: Array<any> = [];
    ModalRef: NgbModalRef;

    StaffId: number;
    StaffName: string;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, private complainService: ComplainService, private modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {

    }

    SetModel(): void {
        let req = new ComplainSearch();
        req.OpenOnly = true;
        req.AssignedTo = [];
        req.AssignedTo.push(this.StaffId);
        req.PageSize = 50000;

        this.complainService.Complain_Search(req).then(data => {
            this.Model = data.Result;
        })
    }

    Open(reqModel: any): void {
        this.Model = [];

        this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true, backdrop:'static' });
        
        this.ModalRef.result.then(() => { },
            () => {
                if (document.querySelector('body > .modal')) {
                    document.body.classList.add('modal-open');
                }
            });
        this.StaffId = reqModel.StaffId;
        this.StaffName = reqModel.Description;
        this.SetModel();
    }
}
